import { resolveMsApiPlatform } from './inboxMsChatPlatform';
import { resolveInboxConversationPhone } from './resolveInboxConversationPhone';

/**
 * Builds the API payload for POST /api/v2/chat_actions/create_customer from a serialized inbox conversation.
 *
 * @param {import('../../presentation/utils/conversationUtils').SerializedConversation} conversation
 * @param {{ retailerId: string|number }} options
 * @returns {Object|null} Payload with chat_id, platform, retailer_id, first_name, and optional fields
 */
export default function buildCreateCustomerPayloadFromConversation(conversation, { retailerId } = {}) {
  if (!conversation?.id || retailerId == null || retailerId === '') return null;

  const platform = resolveMsApiPlatform(conversation.platform);
  if (!platform) return null;

  const rawName = typeof conversation.fullName === 'string' ? conversation.fullName.trim() : '';
  const parts = rawName.split(/\s+/).filter(Boolean);
  const first_name = parts[0] || 'Contact';
  const last_name = parts.length > 1 ? parts.slice(1).join(' ') : undefined;
  const phone = resolveInboxConversationPhone({
    phone: conversation.contactPhone || conversation.phone
  });

  const payload = {
    chat_id: String(conversation.id),
    platform,
    retailer_id: retailerId,
    first_name
  };

  if (last_name) payload.last_name = last_name;
  if (phone) payload.phone = phone;
  if (conversation.email) payload.email = conversation.email;
  if (conversation.externalUserId) payload.external_user_id = conversation.externalUserId;
  if (conversation.country) payload.country = conversation.country;

  return payload;
}
